import { render, staticRenderFns } from "./editConfSubmit.vue?vue&type=template&id=05c29d8e&scoped=true&"
import script from "./editConfSubmit.vue?vue&type=script&lang=js&"
export * from "./editConfSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c29d8e",
  null
  
)

export default component.exports